import { defineStore } from "pinia";

const API_NAME = "rota";
const API_VERSION = "/v1";

const CACHE_TIME_MINUTES = 60 * 4;
const CACHE_SOFT_RECHECK_MINUTES = 15;
const MAX_PAGE_SIZE = 250;

export const useClientsStore = defineStore(
  "clients",
  () => {
    const getAllClients = async function () {
      const myInit = {
        queryStringParameters: {
          pageSize: MAX_PAGE_SIZE,
          sort: JSON.stringify({ initials: 1 }),
        },
      };

      return this.$api
        .getAllPages(API_NAME, `${API_VERSION}/clients`, myInit)
        .then((response) => {
          if (response === false) {
            return [];
          }
          if (response?._embedded?.clients === undefined) {
            throw new Error(
              "pinia client: error fetching clients (no embedded clients found)",
            );
          }
          return response._embedded.clients;
        });
    };

    /* used for cache busting */
    const hasNewerClients = (context, cachedClients) => {
      const largestDateModified = cachedClients.reduce((acc, cur) => {
        if (cur.dateModified > acc) {
          return cur.dateModified;
        }
        return acc;
      }, new Date(0));

      const myInit = {
        queryStringParameters: {
          page: 1,
          pageSize: 1,
          filter: JSON.stringify([
            {
              subject: "dateModified",
              comparison: "gt",
              value: largestDateModified,
            },
          ]),
        },
      };

      return context.$api
        .get(API_NAME, `${API_VERSION}/clients`, myInit)
        .then((response) => {
          if (response?.count > 0) {
            return true;
          }
          return false;
        });
    };

    return {
      getAllClients,
      hasNewerClients,
    };
  },
  {
    localStorageCache: [
      {
        function: "getAllClients",
        expiryCheckFunction: "hasNewerClients",
        options: {
          cacheTimeMinutes: CACHE_TIME_MINUTES,
          expiryCheckTimeMinutes: CACHE_SOFT_RECHECK_MINUTES,
        },
      },
    ],
  },
);
